import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const LANGUAGE_OPTIONS = {
  en: "en",
  es: "es",
};

void i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: ["en", "es"],
    ns: [
      "about-us",
      "account-control",
      "add-2fa",
      "add-email",
      "adults-privacy-policy",
      "banners",
      "become-creator-manual",
      "become-creator",
      "blocked-users",
      "buttons",
      "change-email",
      "chat",
      "common",
      "complete-payment",
      "consent-forms",
      "contact-us",
      "content-request-success",
      "content-request-terms",
      "content-request",
      "cookie-policy",
      "cookies-banner",
      "create-consent-form-link-modal",
      "create-consent-forms-modal",
      "create-content-proposal",
      "create-post",
      "create-subscription",
      "creator-profile",
      "customize-cookies-selection",
      "delete-consent-form-modal",
      "edit-consent-form-name-modal",
      "edit-content-proposal",
      "edit-my-subscription",
      "edit-post",
      "errors",
      "feed",
      "genders",
      "how-it-works",
      "income",
      "invite-co-streamer",
      "labels",
      "landing",
      "livestream",
      "modals",
      "my-profile",
      "my-subscriptions",
      "navigation",
      "new-password",
      "not-found",
      "notifications-settings",
      "notifications",
      "payment-completed",
      "payment-methods",
      "placeholders",
      "privacy-policy",
      "profile-management",
      "promotions",
      "purchases",
      "push-notifications",
      "reports",
      "reset-pwd",
      "resubscribe",
      "settings",
      "sign-in",
      "sign-up-modal",
      "sign-up",
      "sorting",
      "standard-contract",
      "my-profile",
      "creator-profile",
      "statistics",
      "terms-of-use",
      "tour",
      "two-factors-auth",
      "two-factors-settings",
      "uploading",
    ],
    defaultNS: "common",
    debug: false,
    returnObjects: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      requestOptions: {
        cache: "no-store",
      },
    },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
    pluralSeparator: "_",
    compatibilityJSON: "v3",
  });

export default i18next;
